document.querySelectorAll<HTMLElement>('.logo-slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.logo-slider__wrapper');
	const nextButton = slider.querySelector<HTMLElement>('.logo-slider__button--next');
	const prevButton = slider.querySelector<HTMLElement>('.logo-slider__button--prev');

	if (!wrapper || !nextButton || !prevButton) return;

	const slideCount = wrapper.querySelectorAll('.swiper-slide').length;

	const updateNavigationVisibility = (swiper: typeof window.Swiper): void => {
		const isNavigationHidden = slideCount <= swiper.loopedSlides;

		wrapper.parentElement?.classList.toggle('swiper-no-arrows', isNavigationHidden);
	};

	const autoplay = slider.dataset.disableAutoplay !== 'true';

	new (window as Window).Swiper(wrapper, {
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		speed: 800,
		...(autoplay && {
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
		}),
		on: {
			init(swiper: typeof window.Swiper) {
				updateNavigationVisibility(swiper);
			},
		},
	});
});
